module.exports = "<div *ngIf=\"_shown\" class=\"qwin-canvas\">\n    <div class=\"qwin-win\">\n        <div class=\"qwin-head\">ADD LEAD <div class=\"win-x\" [ngClass]=\"{disabled: _innerState == 'loading'}\"><i class=\"fa\" (click)=\"show(false)\"></i></div></div>\n        <lead-import-quick [onChangeState]=\"_setInnerStateFun\"> </lead-import-quick>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/modal-win-new-lead/win.html
// module id = 1444
// module chunks = 9